import React, { createContext } from 'react'

export const TotalUsageContext=createContext(0);